import styles from "./Error500.module.scss";
import { ServerErrorIcon } from "customIcons";
import { Button } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { PAGE_URLS } from "@constants/common";

const Error500: FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate(PAGE_URLS.ISSUE_CREDITS);
  };
  return (
    <div className={styles["error-container"]}>
      <div className={styles["error-container__title"]}>
        Hang on to your hats!
      </div>
      <div className={styles["error-container__message"]}>
        Sorry for the temporary inconvenience, we’ll be up and running again
        before you know it!
      </div>
      <div className={styles["error-container__icon"]}>
        <ServerErrorIcon />
      </div>
      <div className={styles["error-container__refresh-message"]}>
        We’re giving our systems a refresh
      </div>
      <div className={styles["error-container__button"]}>
        <Button onClick={handleBackToHome}>Back to Home</Button>
      </div>
    </div>
  );
};

export default Error500;
